export const MODULE_ID = "VirtoCommerce.AIDocumentProcessing";
export const ENABLED_KEY = "AIDocumentProcessing.EnablePurchaseRequests";
export const DEFAULT_FILES_SCOPE = "purchase-request-sources";
export const FILES_SCOPE_SETTING_NAME = "AIDocumentProcessing.PurchaseRequestFileUploadScopeName";
